/* 各级路由对应的icon */

// 2级路由
export const levelTwoRouterIconList = {
  // 汇入管理
  101: { id: '101', label: '汇入管理', name: 'InnerTransfer', url: require('@/assets/image/level_two_router/inner.png') },
  // 汇出管理
  102: { id: '102', label: '汇出管理', name: 'OutwardTransfer', url: require('@/assets/image/level_two_router/outward.png') },
  110: { id: '110', label: '欧美电商提款', name: 'Settle', url: require('@/assets/image/router/icon-omdstk.png') },
  // 业务管理
  PlaceholderCode: { id: 'PlaceholderCode', label: '业务管理', name: 'BusinessManage', url: require('@/assets/image/level_two_router/business.png') },
  // 基本信息管理
  999: { id: '999', label: '基本信息管理', name: 'InfoManage', url: require('@/assets/image/level_two_router/base-info.png') },
  // 安全管理
  107: { id: '107', label: '安全管理', name: 'SecurityManage', url: require('@/assets/image/level_two_router/security.png') }
}

/**
 * id: 四级路由id
 * name: 路由name
 */
export const routerIconList = {
  // 公司理财：111, 理财列表：20210705, 理财持仓: 20210706, 理财开户: 20210707
  20210705: { id: '20210705', label: '企业理财', name: '', url: require('@/assets/image/router/icon-qylc.png') },
  // 货币兑换: 109, 发起兑换:20200901 兑换记录: 20200902 货币假期: 20200903
  20200901: { id: '20200901', label: '货币兑换', name: '', url: require('@/assets/image/router/icon-hbdh.png') },
  // 欧美电商提款：110, 申请提款：20210427, 提款记录：20210428, 收款人管理：20210429
  20210427: { id: '20210427', label: '欧美电商提款', name: 'Settle', url: require('@/assets/image/router/icon-omdstk.png') },
  10200300: { id: '10200300', label: '跨行汇款', name: 'InterBankOutward', url: require('@/assets/image/router/icon-InterBankOutward.png') },
  10200000: { id: '10200000', label: '同行汇款', name: 'InnerBankOutward', url: require('@/assets/image/router/icon-InnerBankOutward.png') },
  10100100: { id: '10100100', label: '交易明细', name: 'TransactionDetail', url: require('@/assets/image/router/icon-TransactionDetail.png') },
  10100000: { id: '10100000', label: '账户信息', name: 'AccountInfo', url: require('@/assets/image/router/icon-AccountInfo.png') },
  10200400: { id: '10200400', label: '汇款记录', name: 'RecordsOutward', url: require('@/assets/image/router/icon-RecordsOutward.png') },
  10101300: { id: '10101300', label: '汇入汇款申报', name: 'DeclareInner', url: require('@/assets/image/router/icon-DeclareInner.png') },
  10101234: { id: '10101234', label: '申请新币种', name: 'ElectronicAccountOpening', url: require('@/assets/image/router/icon-ElectronicAccountOpening.png') },
  10800000: { id: '10800000', label: '审核指令处理', name: 'DirectiveDeal', url: require('@/assets/image/router/icon-DirectiveDeal.png') },
  11100000: { id: '11100000', label: '审核指令查询', name: 'DirectiveQuery', url: require('@/assets/image/router/icon-DirectiveQuery.png') },
  10200500: { id: '10200500', label: '收款人名册', name: 'PayeeListOutward', url: require('@/assets/image/router/icon-PayeeListOutward.png') },
  tkjl: { id: '20210428', label: '提款记录', name: '', url: require('@/assets/image/router/icon-tkjl.png') },
  10100101: { id: '10100101', label: '汇入路径查询', name: 'PathQueryInner', url: require('@/assets/image/router/icon-PathQueryInner.png') },
  99992000: { id: '99992000', label: '操作日志查询', name: 'QueryLog', url: require('@/assets/image/router/icon-QueryLog.png') },
  10700100: { id: '10700100', label: '登录密码修改', name: 'ModifyPwd', url: require('@/assets/image/router/icon-ModifyPwd.png') },
  10102500: { id: '10102500', label: '对账单下载', name: 'DownloadBill', url: require('@/assets/image/router/icon-DownloadBill.png') },
  20210803: { id: '20210803', label: '薪酬发放', name: 'SalaryOutward', url: require('@/assets/image/router/icon-SalaryOutward.png') },
  10700600: { id: '10700600', label: '账户限额设置', name: 'LimitAmount', url: require('@/assets/image/router/icon-LimitAmount.png') }
}
